import React from "react";
import Modal from 'react-responsive-modal';
import  {firebase}  from '../firebase/firebase';
import database from '../firebase/firebase'
import {ShowNotification} from './HandleNotifications';
import {NotificationContainer} from 'react-notifications';
import uuid from 'uuid';
import {connect} from 'react-redux';
import { loadStudentProfile } from "../actions/_student_actions";

class ModalUserCv extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            file:null,
            id: uuid.v4(),
            loading: false,
            update: false
        }
        this.setRef = this.setRef.bind(this)
    }

    setRef = ref => {
        this.setState({
            file: ref.target.files[0]
        })
    }

    componentDidMount(){
        this.setState({
            upload: false
        })
    }

    uploadDocument = () => {
        this.setState({loading: true})
        let ref = firebase.storage().ref(`documents/${this.props.data.id}`).child('curriculum');
        ref.put(this.state.file).then( (s) => {
            ref.getDownloadURL().then((url)=>{
                database.collection('users').doc(this.props.data.id).update({
                    existCv: true, cv: url
                }).then(() => {
                    this.setState({loading: false, update: true })
                    ShowNotification('success','Guardamos tus datos con exito!', 'Todo Listo')
                    this.props.update(this.props.data.id)
                }).catch(e => {
                    console.log(e)
                })
            })
        })
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.props.close} 
             closeOnOverlayClick={false} >
                 <div className="modal-cv"></div>
                <p className="up-title">¿Deseas actualizar tu CV?</p>
                <div className="modal-file">
                    <div className="modal-couple-inputs">
                        <label className="labels-modal" htmlFor="file">Subir archivo PDF</label>
                        <input type="file" className="modal-input-file" onChange={this.setRef} />
                    </div>
                    {!this.state.loading ? <button className="update-cv modal-button" 
                    onClick={this.uploadDocument}>Actualizar ahora</button> :
                    <p className='labels-modal mx-auto'>Subiendo tu cv espera un momento...</p>}
                    {this.state.update ? 
                    <p className='labels-modal modal-updated mx-auto'>Se actualizo tu Cv corectamente!</p> :
                    null}
                </div>
                <NotificationContainer />
            </Modal>
        );
    }
}
const mapStateToProps = (state) => ({
    id: state.auth.uid,
    data: state.student.profile
});

const mapDispatchToProps = (dispatch) => ({
    update: (id) => dispatch(loadStudentProfile(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalUserCv);
